import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import ProtectRoutes from "./components/ProtectRoutes";
import { ToastContainer } from "react-toastify";
import { openRoutes, protectedRoutes, routeSharedWithApp } from "./data/routes";
import Layout from "./components/Layout";
import "react-loading-skeleton/dist/skeleton.css";
// import ScrollToTop from "./components/ScrollTotop";
import "./index.css";
function App() {
  // useEffect(() => {
  //   localStorage.setItem("alpha_code", "in");
  // }, []);
  return (
    <div className="App">
      {/* <ScrollToTop/> */}
      <Routes>
        <Route element={<Layout />}>
          {openRoutes.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
          <Route element={<ProtectRoutes />}>
            {protectedRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}
          </Route>
        </Route>
        <Route>
          {routeSharedWithApp.map(({ path, element }) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Route>
      </Routes>
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </div>
  );
}

export default App;
